import { useEffect } from 'react';
import { LocalStorageVariables } from '@/enums/LocalStorageVariables';

export const useSystemCheckUserActivity = () => {
  useEffect(() => {
    const setActivityStamp = () => {
      localStorage.setItem(LocalStorageVariables.LastUserActivityTimeStamp, JSON.stringify(new Date().getTime()));
    };
    setActivityStamp();

    window.addEventListener('touchend', setActivityStamp);
    window.addEventListener('mousemove', setActivityStamp);
    window.addEventListener('keypress', setActivityStamp);
    window.addEventListener('click', setActivityStamp);

    return () => {
      window.removeEventListener('touchend', setActivityStamp);
      window.removeEventListener('mousemove', setActivityStamp);
      window.removeEventListener('keypress', setActivityStamp);
      window.removeEventListener('click', setActivityStamp);
    };
  }, []);
};
